/**
 * HTML5 FILE UPLOADER
 */

/**
 * upload
 * @param file
 */
function uploadFile(url, file) {

    if(typeof onUploadStart != "undefined") {
        onUploadStart(file);
    }

    var xhr = new XMLHttpRequest();
    var fd = new FormData();
    xhr.open("POST", Routing.generate(url, {
        "filename": file.name
    }), true);
    xhr.onreadystatechange = function() {
        if (xhr.readyState == 4 && xhr.status == 200) {
            // Every thing ok, file uploaded
            if(typeof handleFileUpload != "undefined") {
                handleFileUpload(xhr.response);
            }
            if(typeof onUploadEnd != "undefined") {
                onUploadEnd(xhr.response);
            }
        }
    };
    fd.append("upload_file", file);
    xhr.send(fd);
}

/**
 * - write and handleFileUpload method
 * - set uploadFileCustomUrl througth setUploadFileCustomUrl
 *
 * - set onUploadStart and onUploadEnd to trigger events
 */